import { render, staticRenderFns } from "./MethodList.vue?vue&type=template&id=f4771604&scoped=true"
import script from "./MethodList.vue?vue&type=script&lang=ts"
export * from "./MethodList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4771604",
  null
  
)

export default component.exports